'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ko_Kr = {
    // pay
    www_title: 'DkNote',
    update_log: '',
    slogan_text1: 'DkNote는 편리하고 빠른 퀴즈 기록과 스마트한 작업 알림을 위해 최선을 다하고 있습니다. ',
    slogan_text2: '중요하고 사소한 일도 잊지 않고, 일과 생활을 질서 있게 하여 효율적인 생활을 시작하세요. ',
    slogan_text3: '여러 장치 간의 즉각적인 클라우드 동기화. (Windows&Mac 버전은 개발중입니다)',
    slogan_h5: 'DkNote는 편리하고 빠른 퀴즈 기록 및 스마트 작업 알림을 위해 최선을 다하고 있습니다. 중요하고 사소한 일이 잊혀지지 않도록 일과 생활이 질서정연해지고 효율적인 삶이 시작됩니다. 여러 기기 간 실시간 클라우드 동기화, (Windows&Mac 버전은 개발 중)',
    android_download: '다운로드',
    ios_download: '앱스토어 설치',
    support_system: '다음 플랫폼이 지원되었습니다',
    windows_button: 'Windows 버전',
    mac_button: 'Mac 버전',
    iphone_button: 'iPhone版',
    android_button: '안드로이드版',
    scan_download_phone: 'QR 코드를 스캔하여 모바일 클라이언트 다운로드',
    content_title1: '즉각적인 데이터 동기화',
    content_text1: 'iPhone&iPad&Android 폰&Android Pad 간에 메모와 콘텐츠를 즉시 동기화할 수 있습니다.',
    content_title2: '풍부한 부티크 노트 스타일',
    content_text2: '더 이상 레코드가 단조롭지 않도록 풍부하고 다채로운 레코드 콘텐츠와 함께 수십 개의 노트 스타일이 신중하게 준비되었습니다.',
    content_title3: '여러 테마 배경 옵션',
    content_text3: '당신을 위해 수십 가지 노트 스타일을 세심하게 준비했습니다. 배경, 테마, 분위기를 바꾸세요.',
    content_title4: '아름다운 위젯',
    content_text4: '빠른 브라우징, 빠른 기록 및 효율적인 생활을 위해 스티커 메모를 휴대폰의 바탕화면에 둘 수 있습니다.',
    content_title5: '맞춤 알림 알림',
    content_text5: '풍부한 미리 알림 설정, 원하는 시간, 생일, 파티, 잊지 못할 중요한 것들을 원하는 시간에 맞춤 설정할 수 있습니다.',
    content_title6: '주간 계획, 월간 계획',
    content_text6: '플랜을 분류하고 커스터마이징하여 사소한 일을 보고 기록하는 것이 합리적이고 편리합니다.',
    support: '고객 지원',
    support_title: 'DkNote-고객 지원',
    support_text1: '의견 및 제안 사항이 있으면 이메일을 보내주십시오. ',
    support_text2: '',
    help: ''
};
exports["default"] = ko_Kr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/ko_Kr.js
// module id = 272
// module chunks = 0